export default __webpack_public_path__ + "static/media/b.70377add.svg";